import Vue from 'vue'
import App from './App'
import store from '@/store'
import router from './router'
import plugin from '@/plugin'

Vue.use(plugin)

new Vue({
  router,
  store,
  mounted() {
    //加载相关用户配置
    this.$store.dispatch('account/load')
    //获取系统信息
    this.$store.commit('ua/load')
    //初始化全屏监听
    this.$store.dispatch('fullscreen/observe')
  },
  render: h => h(App)
}).$mount('#peacock')
